// Include settings-only and tag-only modules when reopening the module picker.
export const savedModuleOverrides = (node) => Object.fromEntries(
  [...new Set([
    ...Object.keys(node.moduleRuntimeOptions || {}),
    ...Object.keys(node.moduleSettings || {}),
    ...Object.keys(node.imageTags || {})
  ])].map((moduleId) => [moduleId, {
    ...(node.moduleRuntimeOptions?.[moduleId] || {}),
    settings: { ...(node.moduleSettings?.[moduleId] || {}) },
    tag: node.imageTags?.[moduleId] || ''
  }])
);